import type { PropsWithChildren } from 'react';
import { DefaultAccountId } from './DefaultAccountId';
import { ForcedAccountIdFromHistoryState } from './ForcedAccountIdFromHistoryState';
import { ForcedAccountIdFromQueryParams } from './ForcedAccountIdFromQueryParam';
import { LastViewedAccountId } from './LastViewedAccountId';
import { RouteDerivedAccountId } from './RouteDerivedAccountId';
import { UpdateLastViewedAccountId } from './UpdateLastViewedAccountId';

/**
 * Decides which account ID is currently active. Each context will override
 * its children contexts, so the outermost context that sets an account ID, wins.
 */
export const ActiveAccountIdContextProvider = ({
  children,
}: PropsWithChildren) => {
  return (
    <RouteDerivedAccountId>
      <ForcedAccountIdFromQueryParams>
        <ForcedAccountIdFromHistoryState>
          <LastViewedAccountId>
            <DefaultAccountId>
              {/* Below here activeAccountId is fully set */}
              {children}

              {/* Side effects from accountID changes */}
              <UpdateLastViewedAccountId />
            </DefaultAccountId>
          </LastViewedAccountId>
        </ForcedAccountIdFromHistoryState>
      </ForcedAccountIdFromQueryParams>
    </RouteDerivedAccountId>
  );
};
